/**
 * Print Info Toggle Action
 * Triggered by: arc:action:printInfoToggle
 *
 * Dispatches a 'print-info:toggle' window event which the drawer-print-info
 * Alpine component listens for to open/close the print info drawer.
 *
 * Usage (button-link action preset):
 *   Action Preset → Print Info Toggle
 *
 * OR via custom event ID:
 *   Action Preset → Custom
 *   Custom Event IDs → printInfoToggle
 */

export const runPrintInfoToggle = async (data = {}) => {
  try {
    window.dispatchEvent(new CustomEvent('print-info:toggle', { detail: data })); 
    console.log('Print info drawer toggled successfully', data);
    return {
      success: true,
      message: 'Print info drawer toggled successfully',
    };
  } catch (error) {
    console.error('Error toggling print info drawer:', error);
    return {
      success: false,
      error: error.message,
    };
  }
};

export default runPrintInfoToggle;
